module Bookhus {
    export class CatalogFilterService implements IContentFilter {
        search(filter: ISearchCridentials) {
            $.ajax({
                url: '/catalog/houses',
                data: filter,
                success: (data, statusText, xhr) => {
                    if (xhr.status == 204) {
                        $('#houseList').html(`
                                    <div class="row">
                                        <div class="col-md-12" style="text-align: center;">
                                            <span>Ingen emner</span>
                                        </div>
                                    </div>
                                `);
                        return;
                    }

                    $('#houseList').html(data);
                    if (window["startKalendere"]) {
                        window["startKalendere"].call();
                    }
                    if (window["startBookingcalendars"]) {
                        window["startBookingcalendars"].call();
                    }
                }
            });
        }
    }

    export class OverviewFilterService implements IContentFilter {
        search(filter: ISearchCridentials) {
            var self = this;
            $.ajax({
                url: '/api/housesearch/getcatalogemneList',
                data: filter,
                success: (data) => {                    
                    $(".overviewWrapper .overview-house").css('display', 'none');
                    for (var i = 0; i < data.length; i++) {
                        $(".overviewWrapper .overview-house[id$=-" + data[i].id + "]").css('display', 'block');
                    }

                    var parsedDate = self.getDate(filter.arrivalDate);
                    if (parsedDate != null && parsedDate != undefined) {
                        $('.overviewWrapper').find('.monthDropdown').val(parsedDate.getMonth() + '');
                        $('.overviewWrapper').find('.yearDropdown').val(parsedDate.getFullYear() + '');
                        $('.hide-month-selector-fields').trigger('click');
                    }
                }
            });
        }

        private getDate(input: string) {            
            return $.datepicker.parseDate($.datepicker.regional[$.datepicker.regional.bookhuscurrent].dateFormat, input);
        }
    }

    export class OverviewRowFilterService implements IContentFilter {
        private calendar: OverviewCalendar;
        constructor(calendar: OverviewCalendar = null) {
            this.calendar = calendar;
        }
        search(filter: ISearchCridentials) {
            var self = this;
            $.ajax({
                url: '/api/housesearch/getcatalogemneList',
                data: filter,
                success: (data) => {
                    $('.ov-row[id*="house-"] ').css('display', 'none');
                    for (var i = 0; i < data.length; i++) {
                        $(".ov-row[id$=-" + data[i].id + "]").css('display', 'block');
                    }
                    var parsedDate = self.getDate(filter.arrivalDate);
                    if (self.calendar != null && parsedDate != null) {
                        self.calendar.setDate(parsedDate);
                    }
                }
            });
        }

        private getDate(input: string) {
            return $.datepicker.parseDate($.datepicker.regional[$.datepicker.regional.bookhuscurrent].dateFormat, input);
        }
    }

    export class CatalogEmneListFilterService implements IEmneFilter {
        search(filter: ISearchCridentials, text: string): JQueryXHR {
            return $.ajax({
                url: '/api/GetCatalogEmneList',
                data: filter
            });
        }
    }
}